import type { OpportunityRelatedDeal } from '~/hooks/apis/offers/useGetOpportunityRelated';

import { formatDateWithClock, isValidDateString } from '~/services/TimeService';

export function getUniqueRoomAssets(deals?: Array<OpportunityRelatedDeal>) {
  const seenSfids = new Set<string>();

  return (deals ?? []).reduce<Array<NonNullable<OpportunityRelatedDeal['room_asset']>>>((roomAssets, deal) => {
    const roomAsset = deal.room_asset;

    if (!roomAsset?.sfid || seenSfids.has(roomAsset.sfid)) {
      return roomAssets;
    }

    seenSfids.add(roomAsset.sfid);
    roomAssets.push(roomAsset);
    return roomAssets;
  }, []);
}

export function formatSyncedDate(value?: string | null) {
  if (!value) {
    return undefined;
  }

  return isValidDateString(value) ? formatDateWithClock(value) : value;
}

export function formatCreatedOrModifiedBy(name?: string | null, when?: string | null) {
  const formattedWhen = formatSyncedDate(when);

  if (!name && !formattedWhen) {
    return undefined;
  }

  return [name, formattedWhen].filter(Boolean).join(', ');
}
